import { render, staticRenderFns } from "./jstCourse.vue?vue&type=template&id=a14cc504&scoped=true&"
import script from "./jstCourse.vue?vue&type=script&lang=js&"
export * from "./jstCourse.vue?vue&type=script&lang=js&"
import style0 from "./jstCourse.vue?vue&type=style&index=0&id=a14cc504&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14cc504",
  null
  
)

export default component.exports